import React from "react";
import { motion } from "framer-motion";
import img from "../../assets/About/about-01.jpeg";

const AboutPageSection = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0B1C2D";

  return (
    <>
    <div className="bg-[#FAF9F6] font-serif overflow-hidden">
      {/* --- 3. THE FIRM'S ETHOS (Enhanced Design) --- */}
      <section className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          {/* Part A: Trust & Relationship */}
          <div className="flex flex-col lg:flex-row gap-16 items-center mb-32">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              className="lg:w-1/2"
            >
              <span
                style={{ color: brandGold }}
                className="text-xs font-bold tracking-[0.3em] uppercase block mb-4"
              >
                Core Values
              </span>
              <h2
                className="text-4xl md:text-5xl font-bold mb-8 leading-tight"
                style={{ color: darkGreen }}
              >
                Foundations of <br />{" "}
                <span className="italic font-light">Client Trust</span>
              </h2>
              <p className="text-gray-600 font-sans text-lg leading-relaxed">
                NYAYSAKTI law firm focuses on building professional
                relationships with its clients based on
                <span className="font-semibold text-black">
                  {" "}
                  trust, confidentiality, and sound business and technical
                  methodology
                </span>
                . Our approach is rooted in an all-legal services philosophy,
                ensuring consistent quality that has ranked us as leaders in our
                field.
              </p>
            </motion.div>
            <div className="lg:w-1/2 relative">
              <div className="aspect-video bg-[#f3f3f3] overflow-hidden">
                <div
                  className="w-full h-full border-l-8"
                  style={{ borderColor: brandGold }}
                >
                  {/* Optional: Add a high-end office image here */}
                  <div className="p-12 opacity-20 text-8xl font-serif">
                    NYAYSAKTI
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Part B: Specialized Services (The Grid) */}
          <div className="grid lg:grid-cols-2 gap-20">
            {/* Wealth & Litigation */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="p-10 border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
              style={{ borderTop: `4px solid ${brandGold}` }}
            >
              <h3
                className="text-2xl font-bold mb-6"
                style={{ color: darkGreen }}
              >
                Private Wealth & Litigation
              </h3>
              <p className="text-gray-600 font-sans leading-relaxed text-sm mb-6">
                We focus on legal services for private wealth clients across all
                specialist areas:
              </p>
              <ul className="grid grid-cols-2 gap-3 text-[11px] uppercase tracking-widest font-bold text-gray-500">
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Human Rights
                </li>
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Writ / SLP
                </li>
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Business Disputes
                </li>
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Real Estate
                </li>
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Family Law
                </li>
                <li className="flex items-center gap-2">
                  <span
                    className="w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: brandGold }}
                  ></span>{" "}
                  Criminal Law
                </li>
              </ul>
            </motion.div>

            {/* Advisory & Implementation */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-[#0B1C2D] p-10 text-white"
            >
              <h3
                className="text-2xl font-bold mb-6"
                style={{ color: brandGold }}
              >
                Advisory & Implementation
              </h3>
              <p className="text-gray-300 font-sans leading-relaxed text-sm mb-8">
                Beyond litigation, we provide strategic recurring legal services
                including company secretarial work, family protocols, and estate
                planning.
              </p>
              <div className="space-y-4 border-t border-gray-700 pt-6">
                <p className="text-xs tracking-tighter text-gray-400 uppercase italic">
                  Complex Legal Solutions for:
                </p>
                <div className="flex flex-wrap gap-x-6 gap-y-2">
                  <span className="text-sm border-b border-gray-600 pb-1">
                    Asset Acquisition
                  </span>
                  <span className="text-sm border-b border-gray-600 pb-1">
                    Wealth Restructuring
                  </span>
                  <span className="text-sm border-b border-gray-600 pb-1">
                    Probate Services
                  </span>
                  <span className="text-sm border-b border-gray-600 pb-1">
                    Conveyance Work
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* 1. HERO SECTION */}
      <section className="relative min-h-[90vh] flex items-center px-6 md:px-12 pt-20">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="relative z-10"
          >
            <div className="flex items-center gap-4 mb-6">
              <div
                className="w-12 h-[1px]"
                style={{ backgroundColor: brandGold }}
              ></div>
              <p
                className="uppercase tracking-[0.4em] text-[10px] font-bold"
                style={{ color: brandGold }}
              >
                ESTABLISHED 1995
              </p>
            </div>

            <h1
              className="text-6xl md:text-8xl font-bold leading-tight mb-8"
              style={{ color: darkGreen }}
            >
              Legacy of <br />
              <span className="italic font-light opacity-60">Justice.</span>
            </h1>

            {/* Content Area with Justified Text */}
            <div className="text-gray-600 text-sm md:text-base leading-relaxed max-w-xl font-sans mb-10 text-justify">
              <p className="mb-4 text-gray-600 text-sm leading-relaxed font-sans">
                <span className="font-bold" style={{ color: darkGreen }}>
                  NYAYSAKTI
                </span>{" "}
                law firm focuses on building professional relationships with its
                clients based on
                <span className="font-semibold">
                  {" "}
                  trust, confidentiality, and sound business and technical
                  methodology across all legal services
                </span>
                .
                <span className="font-normal">
                  {" "}
                  NYAYSAKTI law firm is widely reputed for its consistent
                  quality and expertise and has been ranked as a leader in its
                  field.
                </span>
              </p>
              <p className="mb-4 text-gray-600 text-sm leading-relaxed font-sans">
                <span className="font-bold" style={{ color: darkGreen }}>
                  NYAYSAKTI
                </span>{" "}
                law firm focuses on the provision of legal services to its
                private wealth clients, covering all specialist areas of law
                usually involved, including
                <span className="font-semibold">
                  {" "}
                  human rights matters, writ/SLP, business disputes, commercial,
                  contract, real estate, family, and civil law, as well as
                  criminal issues
                </span>
                , at all wealth tiers.
              </p>

              <p className="mb-4 text-gray-600 text-sm leading-relaxed font-sans">
                <span className="font-bold" style={{ color: darkGreen }}>
                  NYAYSAKTI
                </span>{" "}
                law firm also provides specific advisory, implementation, and
                recurring legal services, including
                <span className="font-semibold">
                  {" "}
                  company secretarial, family protocols, estate and gift
                  planning, probate services
                </span>
                , as well as any advisory and contractual services required in
                relation to
                <span className="font-semibold">
                  {" "}
                  business and wealth restructuring processes, acquisition and
                  disposal of assets, business or passive interests, other
                  business ventures, real estate transactions including
                  conveyance work
                </span>
                , and any other arrangement giving rise to complex legal needs.
              </p>
            </div>

            <button className="px-10 py-4 border border-[#0A1D1B] hover:bg-[#0B1C2D] hover:text-white transition-all duration-500 uppercase tracking-widest text-xs font-bold">
              Explore Our History
            </button>
          </motion.div>

          {/* Hero Image Frame */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
            className="relative"
          >
            <div
              className="absolute inset-0 border-2 translate-x-6 translate-y-6"
              style={{ borderColor: brandGold }}
            ></div>
            <div className="relative aspect-[4/5] bg-gray-200 overflow-hidden shadow-2xl">
              <img
                src={img}
                alt="Law Firm Library"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
              />
            </div>
            {/* Floating Badge */}
            <div
              className="absolute -bottom-10 -left-10 p-8 hidden md:block"
              style={{ backgroundColor: darkGreen }}
            >
              <p className="text-white text-4xl font-bold">30+</p>
              <p
                style={{ color: brandGold }}
                className="text-[10px] uppercase tracking-widest"
              >
                Years of Excellence
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* 2. PHILOSOPHY SECTION (Split Layout) */}
      <section className="py-24" style={{ backgroundColor: darkGreen }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-20 items-center">
          <div className="lg:col-span-4">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Our <br />
              <span style={{ color: brandGold }} className=" font-light">
                Philosophy
              </span>
            </h2>
            <div
              className="w-20 h-[2px] mb-8"
              style={{ backgroundColor: brandGold }}
            ></div>
          </div>

          <div className="lg:col-span-8 grid md:grid-cols-2 gap-12">
            {[
              {
                title: "Integrity",
                desc: "Honesty is the bedrock of our practice. We maintain absolute transparency in every case.",
              },
              {
                title: "Precision",
                desc: "In law, details are everything. Our strategic approach leaves no stone unturned.",
              },
              {
                title: "Tradition",
                desc: "We honor the classical roots of legal practice while embracing modern innovation.",
              },
              {
                title: "Excellence",
                desc: "We strive for nothing less than the most favorable outcome for our patrons.",
              },
            ].map((item, idx) => (
              <div key={idx} className="group">
                <h4
                  style={{ color: brandGold }}
                  className="text-xl font-bold uppercase tracking-widest mb-4 transition-all group-hover:translate-x-2"
                >
                  {item.title}
                </h4>
                <p className="text-gray-400 font-sans leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. THE FOUNDER'S NOTE (Classical Quote) */}
      <section className="py-32 px-6">
        <div className="max-w-4xl mx-auto text-center relative">
          <div
            className="text-[15rem] absolute -top-20 left-0 opacity-[0.03] select-none"
            style={{ color: darkGreen }}
          >
            “
          </div>
          <h2
            className="text-3xl md:text-4xl italic font-light leading-relaxed mb-12"
            style={{ color: darkGreen }}
          >
            "The law is a fortress that protects the weak and keeps the strong
            accountable. At Nyaysakti, we ensure those walls never crumble."
          </h2>
          <div className="w-12 h-[2px] bg-[#E3B66B] mx-auto mb-6"></div>
          <p
            className="uppercase tracking-[0.4em] text-xs font-bold"
            style={{ color: darkGreen }}
          >
            Adv. Vikram Rathore
          </p>
          <p
            className="text-[10px] uppercase tracking-widest mt-2"
            style={{ color: brandGold }}
          >
            Founding Partner
          </p>
        </div>
      </section>

      {/* 4. STATS SECTION */}
      <section className="py-20 border-t border-gray-100 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-12">
          {[
            { label: "Successful Cases", value: "2.5K+" },
            { label: "Expert Attorneys", value: "45+" },
            { label: "Global Clients", value: "800+" },
            { label: "Awards Won", value: "120+" },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <p
                className="text-4xl lg:text-5xl font-bold mb-2"
                style={{ color: darkGreen }}
              >
                {stat.value}
              </p>
              <p
                className="text-[10px] uppercase tracking-[0.3em] font-bold"
                style={{ color: brandGold }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
    </>
  );
};

export default AboutPageSection;

// import React from "react";
// import { motion } from "framer-motion";
// import CountUp from "react-countup";
// import { useInView } from "react-intersection-observer";

// const AboutPageSection = () => {
//   const brandGold = "#E3B66B";
//   const darkGreen = "#0A1D1B";

//   // Scroll observer for stats section
//   const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.6 });

//   return (
//     <div className="bg-[#FAF9F6] font-serif overflow-hidden">

//       {/* 1. HERO SECTION */}
//       <section className="relative min-h-[90vh] flex items-center px-6 md:px-12 pt-20">
//         <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

//           <motion.div
//             initial={{ opacity: 0, x: -50 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8 }}
//             className="relative z-10"
//           >
//             <div className="flex items-center gap-4 mb-6">
//               <div className="w-12 h-[1px]" style={{ backgroundColor: brandGold }}></div>
//               <p className="uppercase tracking-[0.4em] text-[10px] font-bold" style={{ color: brandGold }}>
//                 ESTABLISHED 1995
//               </p>
//             </div>

//             <h1 className="text-6xl md:text-8xl font-bold leading-tight mb-8" style={{ color: darkGreen }}>
//               Legacy of <br />
//               <span className="italic font-light opacity-60">Justice.</span>
//             </h1>

//             <p className="text-gray-600 text-lg leading-relaxed max-w-md font-sans mb-10">
//               Nyaysakti Chambers is built on the pillars of integrity, profound legal expertise,
//               and an unwavering commitment to our clients' success. We don't just practice law;
//               we define it.
//             </p>

//             <button className="px-10 py-4 border border-[#0A1D1B] hover:bg-[#0A1D1B] hover:text-white transition-all duration-500 uppercase tracking-widest text-xs font-bold">
//               Explore Our History
//             </button>
//           </motion.div>

//           {/* Hero Image Frame */}
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1 }}
//             className="relative"
//           >
//             <div className="absolute inset-0 border-2 translate-x-6 translate-y-6" style={{ borderColor: brandGold }}></div>
//             <div className="relative aspect-[4/5] bg-gray-200 overflow-hidden shadow-2xl">
//               <img
//                 src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80"
//                 alt="Law Firm Library"
//                 className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
//               />
//             </div>
//             {/* Floating Badge */}
//             <div className="absolute -bottom-10 -left-10 p-8 hidden md:block" style={{ backgroundColor: darkGreen }}>
//                 <p className="text-white text-4xl font-bold">30+</p>
//                 <p style={{ color: brandGold }} className="text-[10px] uppercase tracking-widest">Years of Excellence</p>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* 2. PHILOSOPHY SECTION (Split Layout) */}
//       <section className="py-24" style={{ backgroundColor: darkGreen }}>
//         <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-20 items-center">

//           <div className="lg:col-span-4">
//              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
//                Our <br />
//                <span style={{ color: brandGold }} className=" font-light">Philosophy</span>
//              </h2>
//              <div className="w-20 h-[2px] mb-8" style={{ backgroundColor: brandGold }}></div>
//           </div>

//           <div className="lg:col-span-8 grid md:grid-cols-2 gap-12">
//             {[
//               { title: "Integrity", desc: "Honesty is the bedrock of our practice. We maintain absolute transparency in every case." },
//               { title: "Precision", desc: "In law, details are everything. Our strategic approach leaves no stone unturned." },
//               { title: "Tradition", desc: "We honor the classical roots of legal practice while embracing modern innovation." },
//               { title: "Excellence", desc: "We strive for nothing less than the most favorable outcome for our patrons." }
//             ].map((item, idx) => (
//               <div key={idx} className="group">
//                 <h4 style={{ color: brandGold }} className="text-xl font-bold uppercase tracking-widest mb-4 transition-all group-hover:translate-x-2">
//                   {item.title}
//                 </h4>
//                 <p className="text-gray-400 font-sans leading-relaxed">
//                   {item.desc}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 3. THE FOUNDER'S NOTE (Classical Quote) */}
//       <section className="py-32 px-6">
//         <div className="max-w-4xl mx-auto text-center relative">
//           <div className="text-[15rem] absolute -top-20 left-0 opacity-[0.03] select-none" style={{ color: darkGreen }}>“</div>
//           <h2 className="text-3xl md:text-4xl italic font-light leading-relaxed mb-12" style={{ color: darkGreen }}>
//             "The law is a fortress that protects the weak and keeps the strong accountable.
//             At Nyaysakti, we ensure those walls never crumble."
//           </h2>
//           <div className="w-12 h-[2px] bg-[#E3B66B] mx-auto mb-6"></div>
//           <p className="uppercase tracking-[0.4em] text-xs font-bold" style={{ color: darkGreen }}>
//             Adv. Vikram Rathore
//           </p>
//           <p className="text-[10px] uppercase tracking-widest mt-2" style={{ color: brandGold }}>
//             Founding Partner
//           </p>
//         </div>
//       </section>

//       {/* 4. STATS SECTION with CountUp */}
//       <section ref={ref} className="py-20 border-t border-gray-100 bg-white">
//         <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 lg:grid-cols-4 gap-12">
//           {[
//             { label: "Successful Cases", value: 2500, suffix: "K+" },
//             { label: "Expert Attorneys", value: 45, suffix: "+" },
//             { label: "Global Clients", value: 800, suffix: "+" },
//             { label: "Awards Won", value: 120, suffix: "+" }
//           ].map((stat, i) => (
//             <div key={i} className="text-center">
//               <p className="text-4xl lg:text-5xl font-bold mb-2" style={{ color: darkGreen }}>
//                 {inView ? <CountUp end={stat.value} duration={2} separator="," /> : 0}{stat.suffix}
//               </p>
//               <p className="text-[10px] uppercase tracking-[0.3em] font-bold" style={{ color: brandGold }}>
//                 {stat.label}
//               </p>
//             </div>
//           ))}
//         </div>
//       </section>

//     </div>
//   );
// };

// export default AboutPageSection;
